import React, { useState, useEffect, useMemo } from 'react';
import { db, getCollectionName, auth } from './firebase';
import { collection, query, onSnapshot, addDoc, updateDoc, deleteDoc, doc, serverTimestamp, orderBy, where } from './firestore-compat';
import { format } from 'date-fns';
import IntranetChat from './IntranetChat';
import IntranetElogios from './IntranetElogios';

// ── Feed ──────────────────────────────────────────────────────────────────────
function Feed() {
  const user = auth.currentUser;
  const COLL = getCollectionName('intranet_posts');
  const [posts, setPosts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formTexto, setFormTexto] = useState('');
  const [formImg, setFormImg] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    return onSnapshot(query(collection(db, COLL), orderBy('criadoEm', 'desc')), snap =>
      setPosts(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }, [COLL]);

  const handlePost = async () => {
    if (!formTexto.trim()) return;
    setSaving(true);
    await addDoc(collection(db, COLL), {
      texto: formTexto.trim(), imgUrl: formImg.trim() || null,
      autorEmail: user?.email || '',
      autorNome: user?.displayName || user?.email?.split('@')[0] || 'Usuário',
      curtidas: [], criadoEm: serverTimestamp(),
    });
    setFormTexto(''); setFormImg(''); setShowForm(false); setSaving(false);
  };

  const toggleLike = async p => {
    const cur = p.curtidas || [];
    const liked = cur.includes(user?.email);
    await updateDoc(doc(db, COLL, p.id), { curtidas: liked ? cur.filter(e => e !== user?.email) : [...cur, user?.email] });
  };

  return (
    <div style={{ maxWidth: 680, margin: '0 auto', padding: '20px 0' }}>
      {/* composer */}
      <div style={{ background: '#fff', borderRadius: 14, padding: 20, marginBottom: 18, border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        {!showForm
          ? <div onClick={() => setShowForm(true)} style={{ display: 'flex', gap: 12, cursor: 'pointer', alignItems: 'center' }}>
              <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, flexShrink: 0 }}>
                {(user?.displayName || user?.email || 'U')[0].toUpperCase()}
              </div>
              <div style={{ flex: 1, padding: '9px 14px', borderRadius: 20, background: '#f1f5f9', color: '#94a3b8', fontSize: '0.87rem' }}>
                Compartilhe uma novidade com a equipe...
              </div>
            </div>
          : <div>
              <textarea value={formTexto} onChange={e => setFormTexto(e.target.value)} placeholder="O que você quer compartilhar?" rows={3} autoFocus
                style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #e2e8f0', fontSize: '0.88rem', resize: 'none', fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', marginBottom: 10 }} />
              <input value={formImg} onChange={e => setFormImg(e.target.value)} placeholder="URL de imagem (opcional)"
                style={{ width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: '0.82rem', marginBottom: 12, boxSizing: 'border-box', outline: 'none' }} />
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowForm(false)} style={{ padding: '7px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', color: '#64748b', fontSize: '0.82rem' }}>Cancelar</button>
                <button onClick={handlePost} disabled={saving || !formTexto.trim()} style={{ padding: '7px 18px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: '0.82rem' }}>Publicar</button>
              </div>
            </div>
        }
      </div>

      {posts.length === 0
        ? <div style={{ textAlign: 'center', color: '#94a3b8', padding: 60, fontSize: '0.85rem' }}>Nenhuma publicação ainda. Seja o primeiro! 📝</div>
        : posts.map(p => {
            const liked = (p.curtidas || []).includes(user?.email);
            const ts = p.criadoEm?.toDate ? p.criadoEm.toDate() : (p.criadoEm ? new Date(p.criadoEm) : null);
            return (
              <div key={p.id} style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', marginBottom: 14, border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginBottom: 12 }}>
                  <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, flexShrink: 0 }}>
                    {(p.autorNome || 'U')[0].toUpperCase()}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, color: '#1e293b', fontSize: '0.88rem' }}>{p.autorNome}</div>
                    {ts && <div style={{ color: '#94a3b8', fontSize: '0.72rem' }}>{format(ts, "dd/MM/yyyy 'às' HH:mm")}</div>}
                  </div>
                  {p.autorEmail === user?.email && (
                    <button onClick={() => deleteDoc(doc(db, COLL, p.id))} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '1rem', padding: '2px 6px', borderRadius: 4 }}>×</button>
                  )}
                </div>
                <div style={{ color: '#374151', fontSize: '0.9rem', lineHeight: 1.65, whiteSpace: 'pre-wrap', marginBottom: 10 }}>{p.texto}</div>
                {p.imgUrl && <img src={p.imgUrl} alt="" onError={e => { e.target.style.display = 'none'; }} style={{ maxWidth: '100%', borderRadius: 10, marginBottom: 10, display: 'block' }} />}
                <div style={{ paddingTop: 10, borderTop: '1px solid #f1f5f9' }}>
                  <button onClick={() => toggleLike(p)} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '5px 13px', borderRadius: 20, border: '1px solid #e2e8f0', background: liked ? '#ede9fe' : '#fff', color: liked ? '#7c3aed' : '#64748b', cursor: 'pointer', fontSize: '0.8rem', fontWeight: liked ? 700 : 400, transition: 'all 0.15s' }}>
                    {liked ? '💜' : '🤍'} {(p.curtidas || []).length}
                  </button>
                </div>
              </div>
            );
          })
      }
    </div>
  );
}

// ── Chamadas ──────────────────────────────────────────────────────────────────
function gerarCodigo() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
}

function Chamadas() {
  const user = auth.currentUser;
  const COLL = getCollectionName('intranet_reunioes');
  const SALAS_RAPIDAS = [
    { id: 'geral', label: 'Geral' }, { id: 'captacao', label: 'Captação' },
    { id: 'enfermagem', label: 'Enfermagem' }, { id: 'direcao', label: 'Direção' },
  ];
  const [room, setRoom] = useState('iw-intranet-geral');
  const [custom, setCustom] = useState('');
  const [inCall, setInCall] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const [reunioes, setReunioes] = useState([]);
  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);

  useEffect(() => {
    const cutoff = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
    return onSnapshot(
      query(collection(db, COLL), orderBy('criadoEm', 'desc')),
      snap => setReunioes(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(r => r.expiresAt > cutoff))
    );
  }, [COLL]);

  const jitsiUrl = `https://meet.jit.si/${room}`;
  const reuniaoAtiva = reunioes.find(r => r.roomId === room);

  const criarOuObterReuniao = async () => {
    if (reuniaoAtiva) return reuniaoAtiva;
    const codigo = gerarCodigo();
    const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();
    await addDoc(collection(db, COLL), {
      roomId: room, codigo,
      criadoPorNome: user?.displayName || user?.email?.split('@')[0] || 'Usuário',
      criadoEm: serverTimestamp(), expiresAt: expires,
    });
    return { roomId: room, codigo };
  };

  const handleEntrar = async () => {
    await criarOuObterReuniao();
    setInCall(true);
  };

  const handleConvidar = async () => {
    await criarOuObterReuniao();
    setShowInvite(true);
  };

  const copyToClipboard = (text, setCopied) => {
    navigator.clipboard.writeText(text).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  };

  const toSlug = (s) => s.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

  return (
    <div style={{ padding: 24, maxWidth: 680, margin: '0 auto' }}>
      {!inCall
        ? <div style={{ background: '#fff', borderRadius: 16, padding: 32, border: '1px solid #e2e8f0', textAlign: 'center' }}>
            <div style={{ fontSize: 52, marginBottom: 14 }}>📹</div>
            <div style={{ fontWeight: 800, fontSize: '1.15rem', color: '#1e293b', marginBottom: 4 }}>Chamadas de Vídeo e Voz</div>
            <div style={{ color: '#64748b', fontSize: '0.82rem', marginBottom: 24 }}>Membros internos e convidados externos podem participar — sem precisar de conta.</div>

            {/* Salas rápidas */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
              {SALAS_RAPIDAS.map(s => (
                <button key={s.id} onClick={() => setRoom(`iw-intranet-${s.id}`)}
                  style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: room === `iw-intranet-${s.id}` ? '#6366f1' : '#fff', color: room === `iw-intranet-${s.id}` ? '#fff' : '#374151', cursor: 'pointer', fontSize: '0.82rem', fontWeight: room === `iw-intranet-${s.id}` ? 700 : 400, transition: 'all 0.15s' }}>
                  {s.label}
                </button>
              ))}
            </div>

            {/* Sala personalizada */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              <input value={custom} onChange={e => setCustom(e.target.value)} placeholder="Criar sala personalizada..."
                style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: '0.85rem', outline: 'none' }}
                onKeyDown={e => { if (e.key === 'Enter' && custom.trim()) setRoom('iw-' + toSlug(custom)); }} />
              <button onClick={() => { if (custom.trim()) setRoom('iw-' + toSlug(custom)); }}
                style={{ padding: '9px 14px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#f8fafc', color: '#374151', cursor: 'pointer' }}>OK</button>
            </div>

            <div style={{ background: '#f8fafc', borderRadius: 10, padding: '10px 14px', marginBottom: 20, fontSize: '0.78rem', color: '#64748b' }}>
              Sala: <strong style={{ color: '#1e293b' }}>{room}</strong>
              {reuniaoAtiva && <span style={{ marginLeft: 10, color: '#16a34a', fontWeight: 700 }}>● Código: {reuniaoAtiva.codigo}</span>}
            </div>

            {/* Botões */}
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={handleEntrar}
                style={{ flex: 2, padding: 14, borderRadius: 12, border: 'none', background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', color: '#fff', fontWeight: 800, fontSize: '0.95rem', cursor: 'pointer', boxShadow: '0 4px 14px rgba(99,102,241,0.35)' }}>
                📹 Entrar na sala
              </button>
              <button onClick={handleConvidar}
                style={{ flex: 1, padding: 14, borderRadius: 12, border: '1px solid #e2e8f0', background: '#fff', color: '#374151', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer' }}>
                🔗 Convidar
              </button>
            </div>

            {/* Reuniões recentes */}
            {reunioes.length > 0 && (
              <div style={{ marginTop: 24, textAlign: 'left' }}>
                <div style={{ fontWeight: 700, color: '#64748b', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Salas Ativas (últimas 24h)</div>
                {reunioes.slice(0, 5).map(r => (
                  <div key={r.id} onClick={() => setRoom(r.roomId)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', borderRadius: 8, background: room === r.roomId ? '#ede9fe' : '#f8fafc', marginBottom: 4, cursor: 'pointer', border: '1px solid #e2e8f0' }}>
                    <span style={{ fontSize: '0.83rem', color: '#1e293b', fontWeight: 600 }}>{r.roomId.replace('iw-intranet-', '').replace('iw-', '').replace(/-/g, ' ')}</span>
                    <span style={{ fontSize: '0.75rem', color: '#6366f1', fontWeight: 700, background: '#ede9fe', padding: '2px 9px', borderRadius: 20 }}>#{r.codigo}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

        : <div style={{ borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
            <div style={{ background: '#1e293b', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ color: '#fff', fontWeight: 700, fontSize: '0.9rem' }}>📹 {room.replace(/iw-intranet-|iw-/g, '').replace(/-/g, ' ')}</span>
              <div style={{ display: 'flex', gap: 6 }}>
                <a href={jitsiUrl} target="_blank" rel="noreferrer"
                  style={{ padding: '5px 12px', borderRadius: 7, border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.1)', color: '#fff', fontSize: '0.78rem', textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>
                  ↗ Nova aba
                </a>
                <button onClick={() => setShowInvite(true)} style={{ padding: '5px 12px', borderRadius: 7, border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.1)', color: '#fff', cursor: 'pointer', fontSize: '0.78rem' }}>🔗 Convidar</button>
                <button onClick={() => setInCall(false)} style={{ padding: '5px 14px', borderRadius: 7, border: 'none', background: '#ef4444', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: '0.82rem' }}>✕ Encerrar</button>
              </div>
            </div>
            <div style={{ background: '#fef9ec', borderBottom: '1px solid #fde68a', padding: '7px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: '0.73rem', color: '#92400e' }}>
                💡 Se você iniciou a reunião, clique em <strong>"Eu sou o anfitrião"</strong> no Jitsi — ou abra em nova aba para melhor experiência.
              </span>
            </div>
            <iframe src={jitsiUrl} allow="camera; microphone; fullscreen; display-capture; autoplay"
              style={{ width: '100%', height: 'calc(100vh - 240px)', border: 'none', display: 'block' }} title="Jitsi Meet" />
          </div>
      }

      {/* Modal de Convite */}
      {showInvite && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 460, maxWidth: '95vw', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
            <div style={{ fontWeight: 800, fontSize: '1.05rem', color: '#1e293b', marginBottom: 4 }}>🔗 Convidar para a Reunião</div>
            <div style={{ color: '#64748b', fontSize: '0.8rem', marginBottom: 22 }}>Qualquer pessoa com o link pode entrar — sem criar conta ou instalar nada.</div>

            {/* Código da sala */}
            <div style={{ background: 'linear-gradient(135deg,#ede9fe,#f0f9ff)', borderRadius: 12, padding: '16px 20px', marginBottom: 16, textAlign: 'center' }}>
              <div style={{ color: '#64748b', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>Código da Sala</div>
              <div style={{ fontSize: '2.2rem', fontWeight: 900, letterSpacing: 6, color: '#6366f1', fontFamily: 'monospace' }}>
                {reuniaoAtiva?.codigo || reunioes.find(r => r.roomId === room)?.codigo || '------'}
              </div>
              <div style={{ color: '#94a3b8', fontSize: '0.68rem', marginTop: 4 }}>Válido por 24 horas</div>
            </div>

            {/* Link */}
            <div style={{ marginBottom: 14 }}>
              <div style={{ color: '#64748b', fontSize: '0.72rem', marginBottom: 5 }}>LINK DE ACESSO (para externos)</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <div style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#f8fafc', fontSize: '0.75rem', color: '#475569', wordBreak: 'break-all', fontFamily: 'monospace' }}>
                  {jitsiUrl}
                </div>
                <button onClick={() => copyToClipboard(jitsiUrl, setCopiedLink)}
                  style={{ padding: '9px 14px', borderRadius: 8, border: 'none', background: copiedLink ? '#16a34a' : '#6366f1', color: '#fff', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 700, whiteSpace: 'nowrap', transition: 'background 0.2s' }}>
                  {copiedLink ? '✓ Copiado' : 'Copiar'}
                </button>
              </div>
            </div>

            {/* Mensagem completa */}
            <div style={{ marginBottom: 20 }}>
              <div style={{ color: '#64748b', fontSize: '0.72rem', marginBottom: 5 }}>MENSAGEM COMPLETA PARA ENVIAR</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <textarea readOnly rows={3}
                  value={`Você foi convidado para uma reunião!\n\nLink: ${jitsiUrl}\nCódigo da sala: ${reuniaoAtiva?.codigo || reunioes.find(r => r.roomId === room)?.codigo || ''}\n\nClique no link para entrar — sem precisar de conta.`}
                  style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#f8fafc', fontSize: '0.73rem', color: '#475569', resize: 'none', fontFamily: 'inherit' }} />
                <button onClick={() => copyToClipboard(`Você foi convidado para uma reunião!\n\nLink: ${jitsiUrl}\nCódigo da sala: ${reuniaoAtiva?.codigo || reunioes.find(r => r.roomId === room)?.codigo || ''}\n\nClique no link para entrar — sem precisar de conta.`, setCopiedCode)}
                  style={{ padding: '9px 14px', borderRadius: 8, border: 'none', background: copiedCode ? '#16a34a' : '#374151', color: '#fff', cursor: 'pointer', fontSize: '0.75rem', fontWeight: 700, whiteSpace: 'nowrap', transition: 'background 0.2s', alignSelf: 'stretch' }}>
                  {copiedCode ? '✓ Copiado' : 'Copiar'}
                </button>
              </div>
            </div>

            <div style={{ background: '#fef3c7', borderRadius: 8, padding: '10px 14px', marginBottom: 20, fontSize: '0.75rem', color: '#92400e' }}>
              💡 <strong>Proteção extra:</strong> ao entrar na reunião, o primeiro participante pode definir uma senha diretamente no Jitsi. Essa senha será pedida para quem entrar depois.
            </div>

            <button onClick={() => setShowInvite(false)}
              style={{ width: '100%', padding: 12, borderRadius: 10, border: '1px solid #e2e8f0', background: '#fff', color: '#64748b', cursor: 'pointer', fontWeight: 700, fontSize: '0.88rem' }}>
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Ranking ───────────────────────────────────────────────────────────────────
function Ranking() {
  const mesSel = format(new Date(), 'yyyy-MM');
  const [elogios, setElogios] = useState([]);
  const [setores, setSetores] = useState([]);

  useEffect(() => {
    return onSnapshot(query(collection(db, getCollectionName('intranet_elogios')), where('mes', '==', mesSel), orderBy('criadoEm', 'desc')),
      snap => setElogios(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }, [mesSel]);

  useEffect(() => {
    return onSnapshot(query(collection(db, getCollectionName('intranet_setores')), orderBy('ordem', 'asc')),
      snap => setSetores(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }, []);

  const topPessoas = useMemo(() => {
    const m = {};
    elogios.forEach(e => {
      if (!m[e.colaborador]) m[e.colaborador] = { nome: e.colaborador, setorNome: e.setorNome, count: 0 };
      m[e.colaborador].count++;
    });
    return Object.values(m).sort((a, b) => b.count - a.count).slice(0, 10);
  }, [elogios]);

  const topSet = useMemo(() => {
    const m = {};
    elogios.forEach(e => {
      if (!m[e.setorId]) { const s = setores.find(x => x.id === e.setorId); m[e.setorId] = { nome: e.setorNome, cor: s?.cor || '#6366f1', count: 0 }; }
      m[e.setorId].count++;
    });
    return Object.values(m).sort((a, b) => b.count - a.count);
  }, [elogios, setores]);

  const MEDALS = ['🥇', '🥈', '🥉'];
  const POD_HEIGHTS = [130, 100, 80];
  const POD_COLORS = ['linear-gradient(180deg,#fbbf24,#d97706)', 'linear-gradient(180deg,#94a3b8,#64748b)', 'linear-gradient(180deg,#fb923c,#c2410c)'];
  const podOrder = [topPessoas[1], topPessoas[0], topPessoas[2]].filter(Boolean);
  const podRanks = topPessoas[1] ? [2, 1, 3] : [1, 2, 3];

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '20px 0' }}>
      <div style={{ background: '#fff', borderRadius: 14, padding: 28, marginBottom: 18, border: '1px solid #e2e8f0' }}>
        <div style={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', marginBottom: 20 }}>⭐ Top Colaboradores — {format(new Date(), 'MMMM yyyy')}</div>
        {topPessoas.length === 0
          ? <div style={{ color: '#94a3b8', textAlign: 'center', padding: 40 }}>Nenhum elogio registrado este mês</div>
          : <>
              {topPessoas.length >= 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', gap: 10, marginBottom: 28 }}>
                  {podOrder.map((c, i) => (
                    <div key={c.nome} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 110 }}>
                      <div style={{ fontSize: 22, marginBottom: 4 }}>{MEDALS[podRanks[i] - 1]}</div>
                      <div style={{ fontWeight: 700, fontSize: '0.8rem', color: '#1e293b', textAlign: 'center' }}>{c.nome}</div>
                      <div style={{ fontSize: '0.7rem', color: '#64748b', marginBottom: 8 }}>{c.count} elogio{c.count > 1 ? 's' : ''}</div>
                      <div style={{ width: '100%', height: POD_HEIGHTS[i], background: POD_COLORS[i], borderRadius: '8px 8px 0 0', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 8, color: '#fff', fontWeight: 800, fontSize: '1.1rem' }}>
                        {podRanks[i]}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {topPessoas.slice(3).map((c, i) => (
                <div key={c.nome} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 12px', borderRadius: 8, background: '#f8fafc', marginBottom: 6 }}>
                  <span style={{ color: '#94a3b8', fontWeight: 700, width: 24, textAlign: 'center', fontSize: '0.85rem' }}>{i + 4}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, color: '#1e293b', fontSize: '0.86rem' }}>{c.nome}</div>
                    <div style={{ color: '#64748b', fontSize: '0.72rem' }}>{c.setorNome}</div>
                  </div>
                  <span style={{ fontWeight: 700, color: '#6366f1', fontSize: '0.85rem' }}>{c.count} ⭐</span>
                </div>
              ))}
            </>
        }
      </div>

      <div style={{ background: '#fff', borderRadius: 14, padding: 24, border: '1px solid #e2e8f0' }}>
        <div style={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', marginBottom: 16 }}>🏆 Setores em Destaque</div>
        {topSet.length === 0
          ? <div style={{ color: '#94a3b8', textAlign: 'center', padding: 24 }}>Sem dados este mês</div>
          : topSet.map((s, i) => (
              <div key={s.nome} style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                <span style={{ color: '#94a3b8', width: 20, fontWeight: 700, fontSize: '0.82rem' }}>{i + 1}</span>
                <div style={{ width: 10, height: 10, borderRadius: '50%', background: s.cor, boxShadow: `0 0 6px ${s.cor}88`, flexShrink: 0 }} />
                <div style={{ flex: 1, fontWeight: 600, color: '#1e293b', fontSize: '0.86rem' }}>{s.nome}</div>
                <div style={{ height: 8, borderRadius: 4, background: s.cor, opacity: 0.7, width: `${Math.max(20, Math.round((s.count / (topSet[0]?.count || 1)) * 160))}px`, transition: 'width 0.8s' }} />
                <span style={{ fontWeight: 700, color: '#374151', minWidth: 30, textAlign: 'right', fontSize: '0.85rem' }}>{s.count}</span>
              </div>
            ))
        }
      </div>
    </div>
  );
}

// ── Ramais ────────────────────────────────────────────────────────────────────
// Formato de armazenamento: { nome: 'TI', posicoes: [{id, nome, ramal, cargo, numero, x, y}] }
// Exibição: lista plana Setor | Colaborador | Ramal | Cargo
function Ramais() {
  const COLL = getCollectionName('intranet_saloes');

  const [saloes, setSaloes] = useState([]);   // documentos crus do Supabase
  const [busca, setBusca] = useState('');
  const [setorFiltro, setSetorFiltro] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [modal, setModal] = useState(null);
  // modal: { mode:'add'|'edit', docId?, posId?, setor, colaborador, ramal, cargo }

  useEffect(() => {
    return onSnapshot(collection(db, COLL), snap => {
      setSaloes(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
  }, [COLL]);

  // Achata os salões em linhas individuais
  const lista = useMemo(() => {
    const q = busca.toLowerCase();
    const rows = [];
    saloes.forEach(s => {
      (s.posicoes || []).forEach(p => {
        rows.push({
          docId: s.id,
          setor: s.nome || '',
          posId: p.id,
          colaborador: p.nome || '',
          ramal: p.ramal || '',
          cargo: p.cargo || '',
          numero: p.numero,
        });
      });
    });
    return rows
      .filter(r => !setorFiltro || r.setor === setorFiltro)
      .filter(r => !q || [r.setor, r.colaborador, r.ramal, r.cargo].some(v => v?.toLowerCase().includes(q)))
      .sort((a, b) => (a.setor || '').localeCompare(b.setor || '') || (Number(a.numero) || 0) - (Number(b.numero) || 0));
  }, [saloes, busca, setorFiltro]);

  const setores = useMemo(() => [...new Set(saloes.map(s => s.nome).filter(Boolean))].sort(), [saloes]);

  async function salvar() {
    if (!modal) return;
    const { mode, docId, posId, setor, colaborador, ramal, cargo } = modal;
    const setorNome = setor.trim();
    if (!setorNome) return alert('Informe o setor.');

    try {
      if (mode === 'add') {
        // Encontra ou cria documento do setor
        let sDoc = saloes.find(s => s.nome === setorNome);
        const novaPosicao = {
          id: Date.now().toString(),
          nome: colaborador.trim(),
          ramal: ramal.trim(),
          cargo: cargo.trim(),
          numero: (sDoc?.posicoes?.length || 0) + 1,
          x: 0, y: 0,
        };
        if (sDoc) {
          const posicoes = [...(sDoc.posicoes || []), novaPosicao];
          await updateDoc(doc(db, COLL, sDoc.id), { posicoes });
        } else {
          await addDoc(collection(db, COLL), { nome: setorNome, posicoes: [novaPosicao] });
        }
      } else {
        // Editar posição existente
        const sDoc = saloes.find(s => s.id === docId);
        if (!sDoc) return;
        const posicoes = (sDoc.posicoes || []).map(p =>
          p.id === posId ? { ...p, nome: colaborador.trim(), ramal: ramal.trim(), cargo: cargo.trim() } : p
        );
        await updateDoc(doc(db, COLL, docId), { posicoes });
      }
      setModal(null);
    } catch (e) { alert('Erro ao salvar:\n' + e.message); }
  }

  async function excluir() {
    if (!modal?.posId || !window.confirm('Excluir este ramal?')) return;
    const { docId, posId } = modal;
    const sDoc = saloes.find(s => s.id === docId);
    if (!sDoc) return;
    try {
      const posicoes = (sDoc.posicoes || []).filter(p => p.id !== posId);
      if (posicoes.length === 0) {
        await deleteDoc(doc(db, COLL, docId));
      } else {
        await updateDoc(doc(db, COLL, docId), { posicoes });
      }
      setModal(null);
    } catch (e) { alert('Erro:\n' + e.message); }
  }

  const EMPTY_MODAL = { mode: 'add', setor: setorFiltro, colaborador: '', ramal: '', cargo: '' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 16 }}>

      {/* toolbar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <input
          value={busca} onChange={e => setBusca(e.target.value)}
          placeholder="Buscar colaborador, ramal, cargo..."
          style={{ padding: '7px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, flex: 1, minWidth: 180, outline: 'none' }}
        />
        <button
          onClick={() => setEditMode(v => !v)}
          style={{ padding: '7px 14px', borderRadius: 8, border: 'none', background: editMode ? '#f59e0b' : '#e5e7eb', color: editMode ? '#fff' : '#374151', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
        >{editMode ? '✏️ Editando' : '✏️ Editar'}</button>
        {editMode && (
          <button
            onClick={() => setModal(EMPTY_MODAL)}
            style={{ padding: '7px 14px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
          >+ Ramal</button>
        )}
      </div>

      {/* filtros de setor */}
      {setores.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button
            onClick={() => setSetorFiltro('')}
            style={{ padding: '4px 12px', borderRadius: 20, border: '1px solid #e2e8f0', fontSize: 12, fontWeight: 600, cursor: 'pointer', background: !setorFiltro ? '#6366f1' : '#fff', color: !setorFiltro ? '#fff' : '#374151' }}
          >Todos</button>
          {setores.map(s => (
            <button key={s} onClick={() => setSetorFiltro(s === setorFiltro ? '' : s)}
              style={{ padding: '4px 12px', borderRadius: 20, border: '1px solid #e2e8f0', fontSize: 12, fontWeight: 600, cursor: 'pointer', background: setorFiltro === s ? '#6366f1' : '#fff', color: setorFiltro === s ? '#fff' : '#374151' }}
            >{s}</button>
          ))}
        </div>
      )}

      {/* tabela */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        {lista.length === 0 ? (
          <div style={{ padding: 48, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
            {saloes.length === 0 ? 'Nenhum ramal cadastrado. Clique "Editar" → "+ Ramal" para começar.' : 'Nenhum resultado para essa busca.'}
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                <th style={{ padding: '10px 14px', textAlign: 'left', color: '#64748b', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Setor</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', color: '#64748b', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Colaborador</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', color: '#64748b', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em', width: 110 }}>Ramal</th>
                <th style={{ padding: '10px 14px', textAlign: 'left', color: '#64748b', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Cargo</th>
                {editMode && <th style={{ width: 52 }} />}
              </tr>
            </thead>
            <tbody>
              {lista.map((r, i) => (
                <tr key={r.id} style={{ borderBottom: '1px solid #f1f5f9', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ padding: '9px 14px' }}>
                    <span style={{ background: '#ede9fe', color: '#6366f1', fontWeight: 700, padding: '2px 9px', borderRadius: 20, fontSize: 11 }}>{r.setor || '—'}</span>
                  </td>
                  <td style={{ padding: '9px 14px', fontWeight: 600, color: '#1e293b' }}>{r.colaborador || <span style={{ color: '#9ca3af' }}>—</span>}</td>
                  <td style={{ padding: '9px 14px' }}>
                    {r.ramal
                      ? <span style={{ fontFamily: 'monospace', fontWeight: 700, color: '#1e293b', fontSize: 14 }}>☎ {r.ramal}</span>
                      : <span style={{ color: '#9ca3af' }}>—</span>}
                  </td>
                  <td style={{ padding: '9px 14px', color: '#64748b' }}>{r.cargo || <span style={{ color: '#9ca3af' }}>—</span>}</td>
                  {editMode && (
                    <td style={{ padding: '9px 14px', textAlign: 'center' }}>
                      <button
                        onClick={() => setModal({ mode: 'edit', docId: r.docId, posId: r.posId, setor: r.setor, colaborador: r.colaborador, ramal: r.ramal, cargo: r.cargo })}
                        style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: 12 }}
                      >✏️</button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* modal */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: 340, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
            <h3 style={{ margin: '0 0 18px', fontWeight: 700 }}>{modal.mode === 'add' ? '+ Adicionar Ramal' : '✏️ Editar Ramal'}</h3>
            <div style={{ marginBottom: 13 }}>
              <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4, fontWeight: 600 }}>Setor</label>
              <input
                list="setores-list"
                placeholder="Selecione ou digite o setor..."
                value={modal.setor}
                onChange={e => setModal(m => ({ ...m, setor: e.target.value }))}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #d1d5db', boxSizing: 'border-box', fontSize: 14 }}
              />
              <datalist id="setores-list">
                {setores.map(s => <option key={s} value={s} />)}
              </datalist>
            </div>
            {[
              { label: 'Colaborador', key: 'colaborador', placeholder: 'Nome do colaborador' },
              { label: 'Ramal', key: 'ramal', placeholder: 'Ex: 1234' },
              { label: 'Cargo', key: 'cargo', placeholder: 'Ex: Coordenador, Analista...' },
            ].map(({ label, key, placeholder }) => (
              <div key={key} style={{ marginBottom: 13 }}>
                <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4, fontWeight: 600 }}>{label}</label>
                <input
                  placeholder={placeholder}
                  value={modal[key]}
                  onChange={e => setModal(m => ({ ...m, [key]: e.target.value }))}
                  onKeyDown={e => e.key === 'Enter' && salvar()}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #d1d5db', boxSizing: 'border-box', fontSize: 14 }}
                />
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
              {modal.mode === 'edit' && (
                <button onClick={excluir} style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', marginRight: 'auto', fontWeight: 600 }}>🗑️ Excluir</button>
              )}
              <button onClick={() => setModal(null)} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#e5e7eb', color: '#374151', cursor: 'pointer' }}>Cancelar</button>
              <button onClick={salvar} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 700 }}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────────────────
const TABS = [
  { k: 'feed',     l: '📰 Feed' },
  { k: 'chat',     l: '💬 Chat' },
  { k: 'chamadas', l: '📹 Chamadas' },
  { k: 'elogios',  l: '🏆 Elogios' },
  { k: 'ranking',  l: '⭐ Ranking' },
  { k: 'ramais',   l: '☎️ Ramais' },
];

const INTRANET_DESATIVADO = true;

export default function Intranet() {
  const [tab, setTab] = useState('feed');

  if (INTRANET_DESATIVADO) {
    return (
      <div style={{ padding: '80px 20px', textAlign: 'center' }}>
        <div style={{ fontSize: 54, marginBottom: 16 }}>🛠️</div>
        <h3 style={{ color: '#1e293b', marginBottom: 8, fontWeight: 700, fontSize: '1.2rem' }}>Intranet desativada</h3>
        <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Este módulo não está mais em uso.</p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9' }}>
      {/* header */}
      <div style={{ background: 'linear-gradient(135deg,#1e293b 0%,#334155 100%)', padding: '16px 24px 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
          <span style={{ fontSize: 22 }}>🏠</span>
          <span style={{ color: '#fff', fontWeight: 800, fontSize: '1.08rem' }}>Intranet IW</span>
          <span style={{ color: '#64748b', fontSize: '0.78rem', marginLeft: 4 }}>Comunicação interna da equipe</span>
        </div>
        <div style={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          {TABS.map(t => (
            <button key={t.k} onClick={() => setTab(t.k)}
              style={{
                border: 'none', padding: '9px 18px', cursor: 'pointer',
                fontSize: '0.82rem', fontWeight: 700, borderRadius: '8px 8px 0 0', transition: 'all 0.15s',
                background: tab === t.k ? (t.k === 'elogios' ? '#261808' : '#f1f5f9') : 'rgba(255,255,255,0.08)',
                color: tab === t.k ? (t.k === 'elogios' ? '#D4B84A' : '#1e293b') : 'rgba(255,255,255,0.7)',
                borderBottom: tab === t.k ? '2px solid #6366f1' : '2px solid transparent',
              }}>
              {t.l}
            </button>
          ))}
        </div>
      </div>

      {/* content */}
      <div style={{ padding: tab === 'elogios' ? 0 : tab === 'chat' ? '0 20px' : '0 20px' }}>
        {tab === 'feed'     && <Feed />}
        {tab === 'chat'     && <div style={{ paddingTop: 20 }}><IntranetChat /></div>}
        {tab === 'chamadas' && <Chamadas />}
        {tab === 'elogios'  && <IntranetElogios />}
        {tab === 'ranking'  && <Ranking />}
        {tab === 'ramais'   && <Ramais />}
      </div>
    </div>
  );
}
